import { takeLatestApiCall } from 'syft-acp-core/sagas/helpers'

import { WORKER_BLOCKS_FETCH_BEGIN } from './action-types'
import { fetchWorkerBlocks } from './api'

export function* saga() {
  yield takeLatestApiCall(WORKER_BLOCKS_FETCH_BEGIN, fetchWorkerBlocks)
}
